import { BoxControl, ButtonControl, IconButtonControl, LinkButtonControl, TextInputControl, Utilities } from "doshx_controls_web";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { change_password } from "../../api/calls/user/change_password";
import { setDrawerOpen, setDrawerPage } from "../../reducers/slices/main";
import { buildUserStateCookieValue, REMEMBER_ME_MAX_AGE_SECONDS, setUser } from "../../reducers/slices/user";
import Cookie from "universal-cookie";
import { useLocation, useNavigate } from "react-router-dom";
import { faArrowLeft, faArrowRight, faCheckCircle, faEye, faEyeSlash } from "@fortawesome/pro-light-svg-icons";
import { OTPInputHandler } from "../../controls/OTPInputHandler";
export const ForgotPasswordPage = () => {
    const cookie = new Cookie();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { user } = useSelector((state) => state.userState);
    const [emailMessage, setEmailMessage] = useState("");
    const [otpError, setOTPError] = useState("");
    const [newPasswordError, setNewPasswordError] = useState("");
    const [confirmNewPasswordError, setConfirmNewPasswordError] = useState("");
    const [enteredOTP, setEnteredOTP] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmNewPassword, setConfirmNewPassword] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [configureNewPassword, setConfigureNewPassword] = useState(false);
    const from = location.state?.from || "/auth/login";
    const [email, setEmail] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const lengthValid = newPassword.length >= 8;
    const uppercaseValid = /[A-Z]/.test(newPassword);
    const numberValid = /\d/.test(newPassword);
    const noSpacesValid = !/\s/.test(newPassword);
    useEffect(() => {
        if (enteredOTP) {
            console.log("Entered OTP:", enteredOTP);
        }
    }, [enteredOTP]);
    const validate = () => {
        let count = 0;
        setEmailMessage("");
        setOTPError("");
        setNewPasswordError("");
        setConfirmNewPasswordError("");
        if (!user.user.email) {
            count++;
            setEmailMessage("Please enter your email to reset your password.");
        }
        if (user.user.reset_password_otp && user.user.reset_password_otp != enteredOTP) {
            count++;
            setOTPError("Entered OTP does not match the one sent to your phone number.");
        }
        if (user.user.reset_password_otp == enteredOTP && configureNewPassword) {
            if (!newPassword) {
                count++;
                setNewPasswordError("New password is required.");
            }
            if (newPassword !== confirmNewPassword) {
                count++;
                setConfirmNewPasswordError("Passwords do not match.");
            }
        }
        return count > 0 ? false : true;
    };
    return (React.createElement(BoxControl, { className: "w-full max-w-md mx-auto flex flex-col gap-y-4 overflow-y-auto mt-4", backgroundColor: "bg-secondary", addPadding: true, variant: "filled", shadowColor: "shadow-primary" },
        React.createElement(IconButtonControl, { icon: faArrowLeft, shape: "circle", size: "xsmall", backgroundColor: "bg-secondary", iconColor: "text-primary", onClick: async () => {
                dispatch(setDrawerPage("login"));
                navigate(from);
            } }),
        React.createElement("div", { className: "text-3xl font-bold" }, user.user.reset_password_otp ? (configureNewPassword ? "Update Password" : "Enter verification code") : "Forgot Password"),
        React.createElement("div", { className: "text-borders-dark/25 font-medium" }, user.user.reset_password_otp
            ? configureNewPassword
                ? ""
                : "We sent a verification code to your phone number."
            : "Enter your phone number below to receive a Verification Code."),
        React.createElement("div", { className: "flex flex-col gap-y-4" },
            user.user.reset_password_otp ? (React.createElement("div", { className: "flex flex-col gap-4" },
                !configureNewPassword && (React.createElement("div", null,
                    React.createElement(OTPInputHandler, { length: user.user.reset_password_otp?.length ?? 6, onChange: (otp) => {
                            console.log("OTP changed:", otp);
                            setEnteredOTP(otp);
                        }, value: enteredOTP }),
                    React.createElement("div", { className: "text-error text-sm font-medium mt-2" }, otpError),
                    React.createElement("div", { className: "flex flex-row justify-start items-center gap-x-2 mb-4 text-sm font-medium" },
                        React.createElement("p", { className: "text-primary" }, "Haven\u2019t received your code?"),
                        React.createElement(LinkButtonControl, { label: "Request a New Code", size: "small", textColor: "text-primary", onClick: () => dispatch(setUser({
                                ...user,
                                user: {
                                    ...user.user,
                                    reset_password_otp: null,
                                },
                            })) })))),
                configureNewPassword && (React.createElement("div", { className: "flex flex-col justify-center gap-y-4 overflow-y-auto mt-4" },
                    React.createElement(TextInputControl, { label: "New Password", value: newPassword, errorText: newPasswordError, backgroundColor: "bg-gray-100", borderColor: "border-transparent", type: showPassword ? "text" : "password", iconColor: "text-primary", endIcon: showPassword ? faEye : faEyeSlash, onClick: () => setShowPassword(!showPassword), onChange: (v) => {
                            setNewPassword(v);
                        } }),
                    React.createElement(TextInputControl, { label: "Confirm New Password", value: confirmNewPassword, errorText: confirmNewPasswordError, backgroundColor: "bg-gray-100", borderColor: "border-transparent", type: showPassword ? "text" : "password", iconColor: "text-primary", endIcon: showConfirmPassword ? faEye : faEyeSlash, onClick: () => setShowConfirmPassword(!showConfirmPassword), onChange: (v) => {
                            setConfirmNewPassword(v);
                        } }))))) : (React.createElement(TextInputControl, { label: "Cell Number", type: "text", value: user.user.cell_number, errorText: emailMessage, backgroundColor: "bg-gray-100", borderColor: "border-transparent", onChange: (v) => {
                    dispatch(setUser({
                        ...user,
                        user: {
                            ...user.user,
                            cell_number: v,
                        },
                    }));
                } })),
            React.createElement("div", { className: "grid" },
                React.createElement(ButtonControl, { label: user.user.reset_password_otp ? (configureNewPassword ? "Update Password" : "Continue") : "Send OTP", loading: isLoading, endIcon: faArrowRight, backgroundColor: "bg-primary", onClick: async () => {
                        if (validate()) {
                            console.log("Validation passed");
                            setIsLoading(true);
                            if (user.user.reset_password_otp) {
                                console.log("Entered OTP on val passed:", enteredOTP);
                                if (enteredOTP === user.user.reset_password_otp && !configureNewPassword) {
                                    console.log("OTP matches, configuring new password");
                                    setConfigureNewPassword(true);
                                }
                                else if (enteredOTP === user.user.reset_password_otp && configureNewPassword) {
                                    change_password({
                                        otp: enteredOTP,
                                        cell_number: user.user.cell_number ?? "",
                                        new_password: newPassword,
                                    }).then((response) => {
                                        const obj = {
                                            ...user,
                                            ...response.content,
                                        };
                                        //Only set the cookie if it has been set before.
                                        //IF it has been set before, then it means that the user has checked the remember me checkbox.
                                        if (cookie.get("user_state")) {
                                            cookie.set("user_state", buildUserStateCookieValue(obj), {
                                                path: "/",
                                                sameSite: "lax",
                                                secure: typeof window !== "undefined" && window.location.protocol === "https:",
                                                maxAge: REMEMBER_ME_MAX_AGE_SECONDS,
                                            });
                                        }
                                        dispatch(setUser(obj));
                                        dispatch(setDrawerOpen(false));
                                        dispatch(setDrawerPage("profile"));
                                        setConfigureNewPassword(false);
                                        // navigate(from, {
                                        //   state: { from: from },
                                        // });
                                        navigate("/home");
                                    });
                                }
                            }
                            else {
                                setConfigureNewPassword(false);
                                const otp = Utilities.generateOTP();
                                console.log("Generated OTP:", otp);
                                // forgot_password({
                                //   otp: otp,
                                //   cell_number: user.user.cell_number ?? "",
                                //   send_sms: true,
                                // }).then((response) => {
                                //   if (response.success) {
                                //     dispatch(
                                //       setUser({
                                //         ...user,
                                //         user: {
                                //           ...user.user,
                                //           reset_password_otp: otp,
                                //         },
                                //       }),
                                //     );
                                //   } else {
                                //     //Failed to send otp!
                                //     console.log("Failed to send otp!", response.message);
                                //     dispatch(
                                //       setMainModal({
                                //         title: "Failed to send OTP",
                                //         messages: [response.message],
                                //       }),
                                //     );
                                //   }
                                // });
                            }
                            setIsLoading(false);
                        }
                    } }),
                configureNewPassword && (React.createElement("div", { className: "flex flex-col justify-center items-start mt-4 text-sm font-medium" },
                    React.createElement(ButtonControl, { startIcon: faCheckCircle, iconColor: lengthValid ? "text-success" : "text-borders-dark", label: "Must be at least 8 characters long", textColor: "text-borders-dark", size: "xsmall", backgroundColor: "bg-transparent", borderColor: "border-borders-light" }),
                    React.createElement(ButtonControl, { startIcon: faCheckCircle, iconColor: uppercaseValid ? "text-success" : "text-borders-dark", label: "Must include at least one uppercase letter (A\u2013Z)", textColor: "text-borders-dark", size: "xsmall", backgroundColor: "bg-transparent", borderColor: "border-borders-light" }),
                    React.createElement(ButtonControl, { startIcon: faCheckCircle, iconColor: numberValid ? "text-success" : "text-borders-dark", label: "Must include at least one number (0\u20139)", textColor: "text-borders-dark", size: "xsmall", backgroundColor: "bg-transparent", borderColor: "border-borders-light" }),
                    React.createElement(ButtonControl, { startIcon: faCheckCircle, iconColor: noSpacesValid ? "text-success" : "text-borders-dark", label: "No spaces allowed", textColor: "text-borders-dark", size: "xsmall", backgroundColor: "bg-transparent", borderColor: "border-borders-light" })))))));
};
